<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="error" dark v-bind="attrs" v-on="on" class="mr-5">
        Update
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">Update Resume</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="handleResumeChange" v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  accept=".doc,.docx,.pdf"
                  placeholder="Upload Resume"
                  prepend-icon="mdi-file"
                  label="Your Resume"
                  :show-size="1000"
                  ref="file"
                  id="file"
                  v-model="resume"
                  :rules="rules"
                ></v-file-input>
              </v-col>

              <v-btn
                type="submit"
                :disabled="!valid"
                color="#FC4A46"
                class="register"
                >Submit</v-btn
              >
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      resume: null,
      resumeId: null,

      valid: false,
      dialog: false,
      email: null,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
      },
    };
  },
  props: ['snackbar', 'snackbarText'],
  methods: {
    handleResumeChange() {
      if (!this.resume) {
        alert('Select a file');
      } else {
        this.$store.dispatch('HANDLE_RESUME_CHANGE', {
          resume: this.resume,
          resumeId: this.$store.getters.getUserData.applicants[0].id,
        });
        // this.snackbar = true;
        // this.snackbarText = 'Your resume has been updated';
      }
    },
  },
};
</script>
